import template from './swag-migration-media-process.html.twig';
import './swag-migration-media-process.scss';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-media-process', {
    template,
});
